/**
 * Kalkulator WHR: widok.
 *
 * Wszystkie obliczenia robi whr-calculator-logic.js (window.DnnzWhrLogic).
 * Ten plik niczego nie dorenderowuje: tabelka przykładów, panel wyniku,
 * blokady i teksty stoją w źródle HTML. Tutaj dzieje się tylko odczyt pól,
 * przełączanie stanów, wstawianie liczb w zdania z atrybutów data-text-*
 * i przyklejany pasek nawigacji.
 *
 * Konfigurację (liczby) skrypt czyta z atrybutu data-config sekcji, który
 * szablon wypełnia z inc/data/whr.php. Stan nie jest nigdzie zapisywany.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function fill(template, values) {
		return String(template || '').replace(/\{([a-z0-9]+)\}/g, function (match, key) {
			return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
		});
	}

	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	function initCalculator(root, L) {
		var cfg;
		try {
			cfg = JSON.parse(root.getAttribute('data-config'));
		} catch (e) {
			return;
		}

		var q = function (selector) {
			return root.querySelector(selector);
		};
		var qa = function (selector) {
			return Array.prototype.slice.call(root.querySelectorAll(selector));
		};

		var sexInputs = qa('[data-role="sex"]');
		var sexError = q('[data-role="sex-error"]');
		var KEYS = ['waist', 'hip'];
		var UNITS = { waist: 'cm', hip: 'cm' };
		var numbers = {};
		var ranges = {};
		var fills = {};
		var errors = {};
		KEYS.forEach(function (key) {
			numbers[key] = q('[data-role="' + key + '-number"]');
			ranges[key] = q('[data-role="' + key + '-range"]');
			fills[key] = q('[data-role="' + key + '-fill"]');
			errors[key] = q('[data-role="' + key + '-error"]');
		});

		var states = {};
		['empty', 'value'].forEach(function (name) {
			states[name] = q('[data-state="' + name + '"]');
		});
		var valueState = states.value;
		var whrEl = q('[data-role="whr"]');
		var lineEl = q('[data-role="line"]');
		var scale = q('[data-role="scale"]');
		var scaleBar = q('[data-role="scale-bar"]');
		var marker = q('[data-role="marker"]');
		var messages = qa('[data-message]');
		var liveEl = q('[data-role="live"]');

		if (!numbers.waist || !numbers.hip || !states.empty || !valueState) {
			return;
		}

		// Odświeżenie strony = stan wyjściowy: przeglądarki potrafią przywrócić
		// wpisane wartości, więc na starcie jawnie wracamy do wartości z HTML.
		KEYS.forEach(function (key) {
			numbers[key].value = numbers[key].defaultValue;
		});
		sexInputs.forEach(function (input) {
			input.checked = input.defaultChecked;
		});

		function text(name) {
			return valueState.getAttribute('data-text-' + name) || '';
		}

		function checkedValue(inputs, fallback) {
			for (var i = 0; i < inputs.length; i++) {
				if (inputs[i].checked) {
					return inputs[i].value;
				}
			}
			return fallback;
		}

		/** Linia pod liczbą: „Wysokie WHR. Próg dla kobiet: 0,85.” */
		function lineText(state) {
			var label = valueState.getAttribute('data-label-' + state.category) || '';
			var rest = fill(text('threshold'), {
				grupa: valueState.getAttribute('data-group-' + state.sex) || '',
				prog: L.formatWhr(L.thresholdHundredths(state.sex, cfg))
			});
			return label + ' ' + rest;
		}

		function updateScale(state) {
			var min = cfg.scale.min;
			var max = cfg.scale.max;
			var at = function (v) {
				return fillPercent(v, min, max);
			};
			var threshold = cfg.thresholds[state.sex];
			var normal = scale.querySelector('[data-seg="normal"]');
			var high = scale.querySelector('[data-seg="high"]');
			var tick = scale.querySelector('[data-tick="threshold"]');
			if (normal) {
				normal.style.width = at(threshold) + '%';
			}
			if (high) {
				high.style.width = 100 - at(threshold) + '%';
			}
			if (tick) {
				tick.style.left = at(threshold) + '%';
				tick.textContent = L.formatWhr(L.thresholdHundredths(state.sex, cfg));
			}
			if (marker) {
				marker.style.left = at(Math.min(max, Math.max(min, state.hundredths / 100))) + '%';
			}
			if (scaleBar) {
				scaleBar.setAttribute('aria-label', fill(text('scale'), { whr: state.whr, prog: L.formatWhr(L.thresholdHundredths(state.sex, cfg)) }));
			}
		}

		function render() {
			var input = { sex: checkedValue(sexInputs, '') };
			KEYS.forEach(function (key) {
				input[key] = numbers[key].value;
			});
			var state = L.evaluate(input, cfg);

			// Komunikaty przy polach.
			KEYS.forEach(function (key) {
				toggle(errors[key], state.fields[key].invalid);
			});
			toggle(sexError, state.sexMissing);

			// Suwak i pole liczbowe to jedna wartość w dwóch kontrolkach.
			KEYS.forEach(function (key) {
				var range = ranges[key];
				var field = state.fields[key];
				var limits = cfg.sliders[key];
				if (!range) {
					return;
				}
				range.classList.toggle('is-empty', field.value === null);
				if (field.value !== null) {
					range.value = Math.min(limits.max, Math.max(limits.min, Math.round(field.value)));
					range.setAttribute('aria-valuetext', numbers[key].value.trim() + ' ' + UNITS[key]);
				} else {
					range.value = limits.min;
					range.setAttribute('aria-valuetext', 'nie podano');
				}
				if (fills[key]) {
					fills[key].style.width = field.value === null ? '0%' : fillPercent(field.value, limits.min, limits.max) + '%';
				}
			});

			var shown = state.hasResult ? 'value' : 'empty';
			Object.keys(states).forEach(function (name) {
				toggle(states[name], name === shown);
			});

			var line = '';
			if (state.hasResult) {
				whrEl.textContent = state.whr;
				// Kolor liczby idzie za kategorią, tak jak odcinek skali (CSS czyta data-category).
				valueState.setAttribute('data-category', state.category);
				line = lineText(state);
				lineEl.textContent = line;
				updateScale(state);
				messages.forEach(function (message) {
					toggle(message, message.getAttribute('data-message') === state.category);
				});
			}

			if (liveEl) {
				liveEl.textContent = state.hasResult ? fill(text('live'), { whr: state.whr }) + ' ' + line : '';
			}
		}

		KEYS.forEach(function (key) {
			numbers[key].addEventListener('input', render);
			if (ranges[key]) {
				ranges[key].addEventListener('input', function () {
					numbers[key].value = ranges[key].value;
					render();
				});
			}
		});
		sexInputs.forEach(function (input) {
			input.addEventListener('change', render);
		});

		render();
	}

	/**
	 * Nawigacja kotwicowa dokleja się pod header motywu i jedzie z czytelnikiem
	 * do końca strony (jak w spalaniu i nawodnieniu: pozycję przełącza skrypt,
	 * bo position: sticky kończy się razem z sekcją bloku).
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'whr-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;
			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		function updateActive(offset) {
			if (!links.length) {
				return;
			}
			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;
			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});
			// Sekcja, która cała przewinęła się nad linię odczytu, oddaje
			// aktywność następnej (rozszerzenie skryptu spalania, jak w nawodnieniu).
			if (current !== -1 && targets[current].getBoundingClientRect().bottom < line) {
				for (var j = current + 1; j < targets.length; j++) {
					if (targets[j]) {
						current = j;
						break;
					}
				}
			}
			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}
			if (current === activeIndex) {
				return;
			}
			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}
			activeIndex = current;
			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;
			var offset = headerOffset();
			root.style.setProperty('--wh-sticky-top', offset + 'px');
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;
			if (!isFixed && top <= offset) {
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}
			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);
		update();
	}

	function init() {
		var L = window.DnnzWhrLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-whr]'));
		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
